'use client'

import { createContext, useContext, useState } from 'react'

type LoaderContextType = {
  isLoaderActive: boolean
  setLoaderActive: (active: boolean) => void
}

const LoaderContext = createContext<LoaderContextType | undefined>(undefined)

export function LoaderProvider({ children }: { children: React.ReactNode }) {
  // Default false so SSR and first paint are not blocked; IntroLoader sets true only when the intro runs.
  const [isLoaderActive, setLoaderActive] = useState(false)
  return (
    <LoaderContext.Provider value={{ isLoaderActive, setLoaderActive }}>
      {children}
    </LoaderContext.Provider>
  )
}

export function useLoader() {
  const context = useContext(LoaderContext)
  if (context === undefined) {
    return { isLoaderActive: false, setLoaderActive: () => {} }
  }
  return context
}
